import { defineComponent as _defineComponent } from 'vue'
export interface Props {
  organization: models.Organization | null;
  course: models.Course | null;
  loading?: boolean;
}


import { computed } from 'vue';

import { dateFilter } from '@filters/date';
import * as models from '@models';
import { useGetter } from '@store';
import { nameFormat } from '@utils/name-format';

import { faInfoCircle } from '@icons/duotone/faInfoCircle';

import CardLoadable from './CardLoadable.vue';

declare module 'vue/types/vue' {
  interface Vue {
    CardCurrentCourse: ComponentWithProps<Props>;
  }
}

const __default__ = { name: 'CardCurrentCourse' };

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    organization: null,
    course: null,
    loading: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props as { organization: models.Organization | null, course: models.Course | null, loading: boolean };

/**
 * `CardCurrentCourse` component properties.
 */


const getCourseStatus = useGetter('courses/getCourseStatus').value;

const status = computed(() => {
  const label = props.course ? getCourseStatus(props.course.id) : '--';

  let className = '';

  if (label === 'IN_PROGRESS') {
    className = 'success';
  } else if (label === 'UPCOMING') {
    className = 'warning';
  } else if (label === 'ENDED') {
    className = 'negative';
  }

  return { label, className };
});

const startDate = computed(() => props.course?.startDate ?? null);
const endDate = computed(() => props.course?.endDate ?? null);

const displayCourseName = computed(() => props.course?.name ?? '--');

const displayDateRange = computed(() => {
  if (!startDate.value || !endDate.value) return '--';

  return (
    dateFilter(startDate.value, 'MM/dd/yyyy').toString() +
    ' - ' +
    dateFilter(endDate.value, 'MM/dd/yyyy').toString()
  );
});

const displayTeacherInfo = computed(() => {
  return props.course ? nameFormat(props.course.teacher) : '--';
});

const displayAssistantInfo = computed(() => {
  return props.course?.teacherAssistant
    ? nameFormat(props.course.teacherAssistant)
    : '--';
});

return { __sfc: true,props, getCourseStatus, status, startDate, endDate, displayCourseName, displayDateRange, displayTeacherInfo, displayAssistantInfo, faInfoCircle, CardLoadable }
}

})